import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Chip,
  FormControl,
  IconButton,
  Link,
  MenuItem,
  Modal,
  Snackbar,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import React, { useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { GetAllDeviceList } from '../../../network/Devices';
import { AssignDeviceToDepartment } from '../../../network/Department';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: '30%',
  maxWidth: '35%',
  bgcolor: 'background.paper',
  // border: '1px solid #000',
  // boxShadow: 24,
  p: 4,
  borderRadius: 1,
  minHeight: '300px',
  maxHeight: '90vh',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column'
};
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

const useStyles = makeStyles((theme) => ({
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  }
}));

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});

export default function DeviceAssignModal({ openAssignedModal, handleClose, data }) {
  const classes = useStyles();
  const [allDevices, setAllDevices] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState([]);
  const [loader, setLoader] = useState(false);
  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    msg: '',
    variant: 'filled',
    severity: ''
  });

  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertMetas({ ...alertMetas, snackBarOpened: false });
  };

  const getDeviceList = async () => {
    try {
      const res = await GetAllDeviceList();
      if (res) {
        setAllDevices(res?.data?.data);
      }
    } catch (error) {
      console.log(error, 'err');
    }
  };

  const assignDevice = async () => {
    const payload = {
      departmentId: data?.id,
      deviceIds: selectedDevice?.map((item) => item?.lock_id)
    };
    setLoader(true);
    try {
      const res = await AssignDeviceToDepartment(payload);
      if (res) {
        setAlertMetas({
          snackBarOpened: true,
          severity: 'success',
          msg: 'Device Assigned Successfully !!',
          variant: 'filled'
        });
        handleClose();
        setTimeout(() => {
          setAlertMetas({ ...alertMetas, snackBarOpened: false });
        }, 4000);
      }
    } catch (error) {
      setAlertMetas({
        snackBarOpened: true,
        severity: 'error',
        msg: error?.response?.data?.message || 'Failed to assign devices',
        variant: 'filled'
      });
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false }), 4000);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getDeviceList();
  }, []);

  return (
    <Box>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        open={alertMetas.snackBarOpened}
        onClose={handleSnackBarClose}
        autoHideDuration={6000}
      >
        <Alert
          onClose={handleSnackBarClose}
          severity={alertMetas.severity}
          variant={alertMetas.variant}
        >
          {alertMetas.msg}
        </Alert>
      </Snackbar>
      <Modal
        open={openAssignedModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        data-testid="assign-device-modal"
      >
        <Box sx={style}>
          <Typography sx={{ fontSize: 18, fontWeight: 900, mb: 2 }}>Assign Devices</Typography>

          <FormControl data-testid="device-select-formcontrol" fullWidth>
            <Autocomplete
              multiple
              id="device_search"
              options={allDevices || []}
              getOptionLabel={(device) => device.name || ''}
              filterSelectedOptions
              value={selectedDevice}
              onChange={(event, newValue) => setSelectedDevice(newValue)}
              renderInput={(params) => (
                <TextField {...params} label="Select Devices" placeholder="Search for devices" />
              )}
              popupIcon={<ExpandMoreIcon />}
              renderTags={(selected, getTagProps) =>
                selected.map((option, index) => (
                  <Chip
                    key={index}
                    label={option.name}
                    {...getTagProps({ index })}
                    color="primary"
                  />
                ))
              }
              renderOption={(props, option) => (
                <MenuItem key={option?.id} value={option} {...props} className={classes.menuItem}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={1}
                    sx={{ width: '100%' }}
                  >
                    {option?.name}
                    {selectedDevice?.includes(option) ? (
                      <IconButton aria-label="remove" color="error">
                        <RemoveOutlinedIcon />
                      </IconButton>
                    ) : (
                      <IconButton aria-label="add" color="success">
                        <AddOutlinedIcon />
                      </IconButton>
                    )}
                  </Stack>
                </MenuItem>
              )}
            />
          </FormControl>
          <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', mt: 'auto' }}>
            {/* <LoadingButton
              size="small"
              type="button"
              variant="contained"
              color="success"
              component="label"
              role={undefined}
              loading={bulkUploadLoader}
            >
              Bulk Upload
              <VisuallyHiddenInput type="file" onChange={handleFileUpload} />
            </LoadingButton> */}
            <Box>
              <Button
                size="small"
                type="button"
                variant="outlined"
                sx={{ mr: 2 }}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <LoadingButton
                size="small"
                type="submit"
                variant="contained"
                loading={loader}
                onClick={assignDevice}
              >
                Assign
              </LoadingButton>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
